import { jsxs as l, jsx as a } from "react/jsx-runtime";
import "../../base-nYmjnkiN.js";
import "react";
import { cssX as r } from "../../core/utils/css.js";
import { c as e } from "../../index-C7ezJk5b.js";
import "react-dom";
import '../../assets/Wrapper.css';/* empty css                     */
import "react-router-dom";
const N = ({
  children: i,
  className: s,
  style: o,
  testId: m,
  modifiers: n,
  ...t
}) => /* @__PURE__ */ l(
  "div",
  {
    className: e(
      r("CornerLabel"),
      s,
      n
    ),
    "data-testid": m,
    style: o,
    ...t,
    children: [
      /* @__PURE__ */ a("div", { className: e(r("CornerLabel__viewer")), children: /* @__PURE__ */ a("div", { className: e(r("CornerLabel__inner")), children: i }) }),
      /* @__PURE__ */ a("div", { className: e(r("CornerLabel__sizer")), children: /* @__PURE__ */ a("div", { className: e(r("CornerLabel__inner")), children: i }) })
    ]
  }
);
export {
  N as default
};
